import { jsPDF } from "jspdf";

export const GeneratePDFReport = (shapeinfo: any) => {
  const doc = new jsPDF();
  // Function to center text
  const centerText = (text: string, yPosition: number) => {
    const textWidth = doc.getTextWidth(text);
    const pageWidth = doc.internal.pageSize.width;
    const xPosition = (pageWidth - textWidth) / 2;
    doc.text(text, xPosition, yPosition);
  };

  // === HEADER (Title with Color) ===
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(0, 51, 153); // Dark Blue Title
  centerText("Location Analysis Report", 15);

  // Add a red underline
  doc.setDrawColor(255, 0, 0);
  const titleWidth = doc.getTextWidth("Location Analysis Report");
  const pageWidth = doc.internal.pageSize.width;
  const lineXStart = (pageWidth - titleWidth) / 2;
  doc.line(lineXStart, 18, lineXStart + titleWidth, 18);

  let yPosition = 30; // Dynamic y position for content placement

  // === SHAPE DATA SECTION ===
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(34, 139, 34); // Forest Green
  centerText("Shape Details:", yPosition);
  yPosition += 10;

  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  //   centerText(`Shape Type: ${shapeinfo.type}`, yPosition);
  //   yPosition += 10;

  if (shapeinfo.type === "circle") {
    centerText(`Center Latitude: ${shapeinfo.center.lat}`, yPosition);
    yPosition += 10;
    centerText(`Center Longitude: ${shapeinfo.center.lng}`, yPosition);
    yPosition += 10;
    centerText(
      `Radius: ${shapeinfo.radius.toFixed(2)} meters / ${(
        shapeinfo.radius / 1609
      ).toFixed(2)} miles`,
      yPosition
    );
    yPosition += 20;
  }

  if (shapeinfo.type === "polygon" && shapeinfo.coordinates) {
    centerText("Coordinates:", yPosition);
    yPosition += 10;
    shapeinfo.coordinates.forEach((coord: any, index: number) => {
      centerText(
        `${index + 1}. Lat: ${coord.lat}, Lng: ${coord.lng}`,
        yPosition
      );
      yPosition += 10;
    });
  }
  // === EMBED CROPPED IMAGE (Moved Above Location Analysis) ===
  if (shapeinfo.cloudinaryUrl) {
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 102, 204); // Blue
    doc.text("Captured Image:", 10, yPosition);
    yPosition += 10;

    const img = new Image();
    img.crossOrigin = "anonymous"; // Prevent CORS issues
    img.src = shapeinfo.cloudinaryUrl;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d")!;

      // Determine cropX dynamically based on screen size
      let cropX = 0; // Default no cropping
      if (window.innerWidth >= 1200) {
        cropX = 450; // More cropping for larger screens
      } else if (window.innerWidth >= 992 && window.innerWidth <= 1199) {
        cropX = 450; // Cropping for 992px-1199px
      } else if (window.innerWidth >= 768 && window.innerWidth <= 991) {
        cropX = 350; // Moderate cropping
      } else {
        cropX = 300; // Less cropping for smaller screens
      }
      const cropWidth = img.width - cropX; // Remaining width
      const cropHeight = img.height; // Full height

      // Set canvas size to cropped dimensions
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // Draw only the cropped portion onto the canvas
      ctx.drawImage(
        img,
        cropX,
        0,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );

      // Convert cropped canvas to base64
      const croppedImage = canvas.toDataURL("image/jpeg");

      // Define PDF placement and scale
      const maxWidth = 190; // Adjusted max width (keeping margins)
      const scaleFactor = maxWidth / cropWidth;
      const newHeight = cropHeight * scaleFactor;

      // Add cropped image to the PDF
      doc.addImage(croppedImage, "JPEG", 10, yPosition, maxWidth, newHeight);
      yPosition += newHeight + 10; // Ensure space between image and next section

      // === MERGED ANALYSIS SECTION ===
      if (shapeinfo.mergedAnalysis) {
        doc.setFont("helvetica", "bold");
        doc.setTextColor(139, 0, 0); // Dark Red for emphasis
        doc.text("Location Analysis:", 10, yPosition);
        yPosition += 10;

        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);

        const analysisData = JSON.parse(shapeinfo.mergedAnalysis);
        const pageHeight = doc.internal.pageSize.height; // Get page height
        const marginBottom = 20; // Margin to avoid printing at the very bottom

        // Iterate through all topics dynamically
        Object.keys(analysisData).forEach((topic) => {
          const topicText = analysisData[topic] || "No analysis available.";

          // Check if there's enough space for a new topic
          if (yPosition + 15 > pageHeight - marginBottom) {
            doc.addPage(); // Add a new page
            yPosition = 20; // Reset yPosition for new page
          }

          // Topic Title
          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 51, 153); // Dark Blue for topic title
          doc.text(`${topic}:`, 10, yPosition);
          yPosition += 7;

          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);

          const splitText = doc.splitTextToSize(topicText, 180); // Wrap text within 180 width

          splitText.forEach((line: string) => {
            // If yPosition is near the bottom, add a new page
            if (yPosition + 7 > pageHeight - marginBottom) {
              doc.addPage();
              yPosition = 20; // Reset yPosition for new page
            }
            doc.text(line, 10, yPosition);
            yPosition += 7; // Move down for the next line
          });

          yPosition += 5; // Extra spacing between topics
        });
      }

      // Save the PDF after image and text are fully processed
      doc.save("Location_Analysis.pdf");
    };
  } else {
    // If no image, generate the report immediately
    if (shapeinfo.mergedAnalysis) {
      doc.setFont("helvetica", "bold");
      doc.setTextColor(139, 0, 0); // Dark Red for emphasis
      doc.text("Location Analysis:", 10, yPosition);
      yPosition += 10;

      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);

      const analysisData = JSON.parse(shapeinfo.mergedAnalysis);

      // Iterate through all topics dynamically
      Object.keys(analysisData).forEach((topic) => {
        const topicText = analysisData[topic] || "No analysis available.";

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 51, 153); // Dark Blue for topic title
        doc.text(`${topic}:`, 10, yPosition);
        yPosition += 7;

        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);

        const splitText = doc.splitTextToSize(topicText, 180); // Wrap text within 180 width
        doc.text(splitText, 10, yPosition);
        yPosition += splitText.length * 7; // Adjust yPosition based on text height
        yPosition += 5; // Extra spacing between topics
      });
    }

    // Save the PDF immediately if there's no image
    doc.save("Location_Analysis.pdf");
  }
};
